(() => {
  'use strict';
  if (window.__fpWishlistHeaderCountV1) return;
  window.__fpWishlistHeaderCountV1 = true;

  let service = null;
  let unsubscribe = null;
  let queued = false;

  function refresh() {
    queued = false;
    const link = document.querySelector('[data-fp-wishlist-header-link]');
    if (!link) return;
    const badge = link.querySelector('[data-fp-wishlist-header-count]');
    if (!badge) return;
    const next = window.FlauschWishlist;
    if (next !== service) {
      if (typeof unsubscribe === 'function') unsubscribe();
      unsubscribe = null;
      service = next;
      if (next && typeof next.subscribe === 'function') {
        try {
          const cleanup = next.subscribe(schedule);
          if (typeof cleanup === 'function') unsubscribe = cleanup;
        } catch {}
      }
    }

    let count = null;
    if (next && typeof next.getState === 'function') {
      try {
        const state = next.getState();
        if (state && Array.isArray(state.items)) {
          count = state.items.filter(item => item && typeof item.productGid === 'string').length;
        }
      } catch {}
    }

    const label = link.dataset.fpWishlistHeaderLabel || 'Schatzkammer';
    if (count === null) {
      badge.hidden = true;
      badge.textContent = '';
      link.setAttribute('aria-label', label);
      return;
    }
    badge.hidden = count === 0;
    badge.textContent = count > 99 ? '99+' : String(count);
    if (count === 0) {
      link.setAttribute('aria-label', label);
    } else if (count === 1) {
      link.setAttribute('aria-label', label + ' – ' + (link.dataset.fpWishlistHeaderOne || '1 Herzensstück'));
    } else {
      link.setAttribute('aria-label', label + ' – ' + count + ' ' + (link.dataset.fpWishlistHeaderMany || 'Herzensstücke'));
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(refresh);
  }

  document.addEventListener('fp:wishlist:state', schedule);
  window.addEventListener('fp:wishlist:state', schedule);
  window.addEventListener('fp:wishlist:client', schedule);
  document.addEventListener('shopify:section:load', schedule);

  function start() {
    schedule();
    let tries = 0;
    const timer = setInterval(() => {
      schedule();
      if (window.FlauschWishlist || ++tries >= 80) clearInterval(timer);
    }, 300);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
